export const MixpanelEventName = {
    BulkActionTriggered: "BulkActionTriggered",
    ButtonClicked: "ButtonClicked",
    CheckboxChanged: "CheckboxChanged",
    FlowInitiated: "FlowInitiated",
    FlowCompleted: "FlowCompleted",
    FlowFailed: "FlowFailed",
    LinkClicked: "LinkClicked",
    MenuItemClicked: "MenuItemClicked",
    MigrateCardBookDemoButtonSeen: "MigrateCardBookDemoButtonSeen",
    MigrateDownload: "MigrateDownload",
    ModalClosed: "ModalClosed",
    ModalOpened: "ModalOpened",
    ObjectResolved: "ObjectResolved",
    PageChanged: "PageChanged",
    PageViewed: "PageViewed",
    RadioChanged: "RadioChanged",
    SwitchChanged: "SwitchChanged",
    TabChanged: "TabChanged",
    TableSorted: "TableSorted",
    TableSearched: "TableSearched"
} as const;

export type MixpanelEventName = (typeof MixpanelEventName)[keyof typeof MixpanelEventName];
